import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useAppSelector, useAppDispatch } from '@/redux/hooks'
import { setQuality } from '@/redux/reducers/room'

// Components
import Item from './components/Item'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface QualityProps {
  className?: string
  handleClose?: () => void
}

const Quality = (props: QualityProps) => {
  const { className, handleClose = () => {} } = props

  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const videoInfo = useAppSelector((state) => state.room.gdata.videoInfo)
  const quality = useAppSelector((state) => state.room.roomData.quality)
  const liveUrlInfo = useAppSelector((state) => state.room.roomData.liveUrlInfo)
  const orginalQuality = { label: t('LiveRoom_Quality_Original'), value: '' }
  const qualityList = liveUrlInfo[0]?.cdnTranscode
    .map((item: string) => {
      return {
        label: item.toLocaleUpperCase(),
        value: item.split('p')[0], // value 不用有 p
      }
    })
    .sort((a: any, b: any) => b.value - a.value)

  const newQualityList = [orginalQuality, ...qualityList]

  const maxQuality = videoInfo?.width

  const handleItemClick = ({ value, isDisabled }: { value: string; isDisabled: boolean }) => {
    if (isDisabled) return

    if (handleClose) handleClose()

    dispatch(setQuality({ quality: value }))
  }

  return (
    <div className={cx('quality', className)}>
      <div className={cx('quality-current')}>
        <p className={cx('quality-current-text')}>{t('LiveRoom_Quality_Current')}</p>
        <p className={cx('quality-current-value')}>{quality ? `${quality}P` : t('LiveRoom_Quality_Original')}</p>
      </div>

      <div className={cx('quality-list')}>
        {newQualityList.map((item, index) => (
          <Item
            key={`${item.value}-${index}`}
            className={cx('quality-list-item')}
            {...item}
            handleItemClick={handleItemClick}
            isDisabled={(!!item.value && maxQuality < item.value) || quality === item.value}
          />
        ))}
      </div>
    </div>
  )
}

export default Quality
